import React from 'react';
import { graphql } from 'gatsby';
import Bayout from '../../../components/blogLayout';
import Logo from '../../../components/logo';
import Seo from '../../../components/seo';

const MacWeb = ({ data }) => {
    return (
        <Bayout>
            <Logo
                color="black-bt"
                tag="h1"
                productName="Release Notes"
                className="text-center text-md-left mb-5"
                fsMax={20}
            />
            <div className="d-flex flex-wrap align-items-stretch w-100">
                {data.allWpReleaseNote.edges.map(({ node }) => {
                    return (
                        <div className="p-5 col-12 panelShadow " key={node.id}>
                            <h3 dangerouslySetInnerHTML={{ __html: node.title }} />
                            <div className="text-muted d-block mb-4">{node.date}</div>
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: node.content,
                                }}
                            />
                        </div>
                    );
                })}
            </div>
        </Bayout>
    );
};

export default MacWeb;

export const pageQuery = graphql`
    query {
        allWpReleaseNote(
            sort: { date: DESC }
            filter: { releaseNotePlatforms: { nodes: { elemMatch: { databaseId: { eq: 1798 } } } } }
        ) {
            edges {
                node {
                    title
                    id
                    date(formatString: "MMMM DD, YYYY")
                    content
                    releaseNotePlatforms {
                        nodes {
                            databaseId
                        }
                    }
                }
            }
        }
    }
`;

export const Head = ({ pageContext }) => <Seo pageContext={pageContext} />;
